export default __webpack_public_path__ + "static/bg-masthead-733fe6480d0aff46860c2beb6070fed8.jpg";